import React from 'react';

export const FundingDisclaimer = () => {
  return (
    <div className="growegy-title10">
      Disclaimer: Results may vary, and there are no guarantees of outcomes. This information is for
      educational purposes only and should not be considered financial advice. Clients are
      responsible for their own financial decisions regarding their company. By proceeding, you
      acknowledge your responsibility for your financial decisions and any outcomes resulting from
      them.
    </div>
  );
};
